import React from "react";
import PropTypes from "prop-types";
import Logo from "./Logo";
import HeaderMenu from "./HeaderMenu";
import FlexRow from "./FlexRow";
import FlexColumn from "./FlexColumn";
import { WHITE } from "../consts/color";

const Header = (props) => (
  <div
    style={{
      backgroundColor: WHITE,
      height: 60,
      boxSizing: "border-box",
      padding: "8px 0px",
      boxShadow: "0px 1px 8px 0 rgba(0, 0, 0, 0.2)",
      zIndex: 10,
      position: "relative",
    }}
  >
    <div className="container">
      <FlexRow alignItems="center" justifyContent="space-between">
        <FlexColumn>
          <Logo src={props.logoSrc} />
        </FlexColumn>
        <FlexColumn>
          <HeaderMenu />
        </FlexColumn>
      </FlexRow>
    </div>
  </div>
);

Header.propTypes = {
  logoSrc: PropTypes.string,
};

Header.defaultProps = {
  logoSrc: null,
};

export default Header;
